import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Text, PaginatedLoadingTable } from '@artprov/design-system';
import { formatCurrency } from '../../../common/utils/functions/formatCurrency';

const columnasHistoricoEmbargos = [
    { key: 'nroEmbargo', label: 'Nro de embargo', type: 'string', sorted: true, width: 150 },
    { key: 'banco', label: 'Banco', type: 'string', sorted: true },
    { key: 'importeRetenido', label: 'Importe retenido', type: 'string', sorted: true },
    { key: 'fecha', label: 'Fecha', type: 'date', sorted: true, width: 90 },
    { key: 'observaciones', label: 'Observaciones', type: 'string', sorted: true },
    { key: 'nroExpediente', label: 'Nro de expediente', type: 'string', sorted: true },
    { key: 'caratula', label: 'Carátula del embargo', type: 'string', sorted: true, tooltipPosition: 'bottom' },
];

const emptyState = {
    icon: 'search_off',
    title: 'No hay registros para mostrar',
    description: 'No se encontraron embargos relacionados a este juicio.',
    iconStyles: 'text-tertiary-70',
    titleStyles: 'text-primary-10',
};

const HistoricoEmbargosCard = ({ data, isLoading }) => {
    const processedData = useMemo(() => {
        return (data || []).map((item) => ({
            ...item,
            _idEmbargo: item.idEmbargo,
            importeRetenido: formatCurrency(item.importeRetenido),
            fecha: item.fecha,
            flag: item.hizoMatch === 'S'
                ? {
                    description: 'Embargo utilizado para el matching',
                    icon: 'check_circle',
                    color: 'default',
                }
                : null,
        }));
    }, [data]);

    const hasMatchingOrigin = useMemo(() => {
        return (data || []).some((item) => item.hizoMatch === 'S');
    }, [data]);

    return (
        <div className="bg-tertiary-100 border border-tertiary-95 rounded py-6">
            <div className="flex items-center justify-between mb-4 px-4">
                <Text variant="subtitle1" className="text-primary-10">
                    Histórico de embargos relacionados a este juicio
                </Text>
            </div>
            <div className={`pr-4 ${hasMatchingOrigin ? 'pl-9' : 'pl-4'}`}>
                <PaginatedLoadingTable
                    columns={columnasHistoricoEmbargos}
                    data={processedData}
                    sortable={true}
                    isLoading={isLoading}
                    showPagination={false}
                    selectable={false}
                    flags={hasMatchingOrigin}
                    emptyState={emptyState}
                    uniqueKey="_idEmbargo"
                />
            </div>
        </div>
    );
};

HistoricoEmbargosCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    isLoading: PropTypes.bool,
};

HistoricoEmbargosCard.defaultProps = {
    data: [],
    isLoading: false,
};

export default HistoricoEmbargosCard;
